var helperMsg = null;
var helperModal = null;

const validarClienteAtivo = (statusCliente) => {
    if (statusCliente != "A") {
        helperMsg.showMsg(
          "Para enviar o orçamento o Status do cliente deve ser Ativo.",
          "warning"
        );

        return false;
    }

    return true;
}

const validarCamposObrigatoriosPreenchidos = (orcamento) => {
    let listaCamposObrigatorios = [
        {campo: "id_forma", msg: "Forma de Pagamento"},
        {campo: "id_condicao", msg: "Prazo"}
    ];

    let valido = true;

    for(let i in listaCamposObrigatorios){
        if(!orcamento[listaCamposObrigatorios[i].campo]){
            valido = false;
            helperMsg.showMsg(
                `Para enviar o orçamento preencha o campo "${listaCamposObrigatorios[i].msg}".`,
                "warning"
            );
        }
    }

    return valido;
}

const validarLeituraInformacoesOrcamento = (orcamento) => {
    if(orcamento.bo_aceite_informacoes_orcamento == "S" || orcamento.bo_aceite_informacoes_orcamento === true || orcamento.bo_aceite_informacoes_orcamento == 1){
        return true;
    }

    helperMsg.showMsg(
        'O campo "Li as informações acima e estou de acordo" é obrigatório.',
        "warning"
    );

    return false;
}

const validarItensSemMargem = async (itens) => {
    let lista = itens.filter(item => item.margem_valor <= 0);
    let valido = (lista.length > 0) ? false : true;

    if(!valido){
        valido = await helperModal.msgBoxConfirm(
                        "Não foi informado um valor de premiação a ser recebido nesse orçamento. Deseja enviar sem o valor de premiação?",
                        {
                        title: "Atenção",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "Sim",
                        cancelVariant: "danger",
                        cancelTitle: "Não",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true
                       }
        );

        return valido;
    } else {
        return valido;
    }
}

const validarItensComDivergenciaNaQuantidade = (itens) => {
    let lista = itens.filter(item => (item.quantidade % item.multiplo) > 0);
    let valido = (lista.length > 0) ? false : true;

    if(!valido) {
        helperMsg.showMsg(
            "Há algum produto com quantidade não adequada ao seu múltiplo.",
            "warning",
            "Produto com múltiplo divergente."
        );
    }

    return valido;
}

const campoNaoInformado = (valor) => valor === null || valor === undefined || valor === "";

const camposEditaveis = [
    "contato",
    "data_validade",
    "previsao_fechamento",
    "observacao",
    "cd_tabelapreco",
    "id_forma",
    "id_condicao",
    "bo_aceite_informacoes_orcamento"
];

const rotulosCampos = {
    contato: "Contato",
    data_validade: "Data de validade",
    previsao_fechamento: "Previsão de fechamento",
    observacao: "Observação",
    cd_tabelapreco: "Tabela de preço",
    id_forma: "Forma de pagamento",
    id_condicao: "Prazo",
    bo_aceite_informacoes_orcamento: "Li as informações acima e estou de acordo"
};

const normalizarValorComparacao = (campo, valor) => {
    if (campo === "bo_aceite_informacoes_orcamento") {
        return valor == "S" || valor === true || valor == 1 ? "S" : "N";
    }

    if (campo === "data_validade" || campo === "previsao_fechamento") {
        if (campoNaoInformado(valor) || valor === "0000-00-00") {
            return "";
        }
        return String(valor).substring(0, 10);
    }

    if (campoNaoInformado(valor)) {
        return "";
    }

    return String(valor);
};

const listarCamposPendentes = (orcamento, dados, validaVazio = true) => {
    let campos = [];

    for(let i in dados){
        if (!camposEditaveis.includes(i) || (typeof dados[i] === "object" && dados[i] !== null)) {
            continue;
        }

        if( (i == "previsao_fechamento" && campoNaoInformado(normalizarValorComparacao(i, dados[i]))) || (i == "contato" && campoNaoInformado(dados[i])) ){
            continue;
        }

        if(validaVazio && campoNaoInformado(orcamento[i])){
            campos.push({ campo: i, motivo: "vazio" });
            continue;
        }

        if(normalizarValorComparacao(i, dados[i]) != normalizarValorComparacao(i, orcamento[i])){
            campos.push({ campo: i, motivo: "alterado" });
        }
    }

    return campos;
}

const existeAlteracoesNaoSalvas = (orcamento, dados, validaVazio = true) => {
    return listarCamposPendentes(orcamento, dados, validaVazio).length > 0;
}

const unirCamposPendentes = (listas) => {
    let motivos = {};

    listas.forEach(lista => {
        lista.forEach(item => {
            if (!motivos[item.campo] || item.motivo == "alterado") {
                motivos[item.campo] = item.motivo;
            }
        });
    });

    return camposEditaveis
        .filter(campo => motivos[campo])
        .map(campo => ({ campo, motivo: motivos[campo] }));
}

const descreverPendencias = (pendencias) => {
    return pendencias.map(item => {
        let nome = rotulosCampos[item.campo] || item.campo;
        let detalhe = item.motivo == "vazio" ? "não informado" : "alterado e não salvo";
        return `${nome} (${detalhe})`;
    }).join(", ");
}

const validarSeOrcamentoJaFoiSalvo = (orcamento, infoOrcamento, orcamentoOriginal, alterarOrcamento = false) => {
    let pendencias = unirCamposPendentes([
        listarCamposPendentes(orcamento, infoOrcamento),
        listarCamposPendentes(orcamento, orcamentoOriginal, false)
    ]);
    let msg = alterarOrcamento ? "alterar" : "enviar";

    if(pendencias.length > 0) {
        helperMsg.showMsg(
            `Salve o orçamento antes de ${msg}. Pendências: ${descreverPendencias(pendencias)}.`,
            "warning",
            "Alterações no orçamento."
        );

        return false;
    }

    return true;
}

export default {
    setarConfiguracao(helperMensagem, helperBvModal){
        helperMsg = helperMensagem;
        helperModal = helperBvModal;
    },
    async validarEnvioOrcamento(statusCliente, orcamento, itens, infoOrcamento, orcamentoOriginal){
        return validarClienteAtivo(statusCliente) &&
               validarLeituraInformacoesOrcamento(orcamento) &&
               validarSeOrcamentoJaFoiSalvo(orcamento, infoOrcamento, orcamentoOriginal) &&
               validarCamposObrigatoriosPreenchidos(orcamento) &&
               (await validarItensSemMargem(itens)) &&
               validarItensComDivergenciaNaQuantidade(itens);
    },
    existeAlteracoesNaoSalvas,
    validarLeituraInformacoesOrcamento,
    validarSeOrcamentoJaFoiSalvo
}